import { useQuery } from '@tanstack/react-query';
import { getPrescriptionService } from '../../../domains/prescriptions';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

/**
 * 가회원(앱 미가입 POS 환자) 상세 — GET /prescription/patients/pos/{pos_patient_id} (백엔드 11/05)
 * 회원 상세와 같은 경로 아래라 getPatientDetail 에 'pos/{id}' 를 넘긴다.
 * 응답: name·phone_number·age·gender·visit_count + prescriptions[{id, received_at, hospital_name, doctor_name, disease_code, medications}]
 */
export const usePosPatientProfile = (posPatientId: number | null | undefined) => {
  return useQuery({
    queryKey: ['pos-patient-profile', posPatientId],
    enabled: posPatientId != null,
    queryFn: async () => {
      const res = await getPrescriptionService().getPatientDetail(`pos/${posPatientId}`);
      if (!isResultOk(res)) return null;
      return res?.data ?? null;
    },
  });
};
